import React from 'react';

const Footer = () => {
  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <button className="footer-logo" onClick={handleLogoClick}>
            Khalil<span>Ahmad</span>
          </button>
          <p className="copyright">© 2026 Khalil Ahmad. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;